var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',{attrs:{"xs":"12"}},[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.payouts,"no-data-text":"Fant ingen utbetalinger"},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var item = ref.item;
return [_c('payouts-table-row',{attrs:{"payout":item}})]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }